exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".dot-line-snap-line-dot-line-DeeLp{position:absolute;pointer-events:none}", ""]);

// Exports
exports.locals = {
	"snap-line-dot-line": "dot-line-snap-line-dot-line-DeeLp"
};